import React from 'react';
import useCurrentTextStyle from '@src/hooks/useCurrentTextStyle';

export const ArticleTitle = ({ article, settings, }) => {
  const { getCurrentTextStyle } = useCurrentTextStyle();

  const {
    colour_scheme,
    classes,
    title_style,
    title_style_mobile,
    title_style_tablet,
    title_style_ultrawide,
    title_style_enable_responsive,
    title_alignment = 'left',
    padding_top = 0,
    padding_right = 0,
    padding_bottom = 0,
    padding_left = 0,
    margin_top = 0,
    margin_right = 0,
    margin_bottom = 0,
    margin_left = 0
  } = settings;

  if (!article?.title) return null;

  return (
    <div 
      className={`
        w-full
        color-${colour_scheme}
        text-${title_alignment}
        pt-[${padding_top}px]
        pb-[${padding_bottom}px]
        pl-[${padding_left}px]
        pr-[${padding_right}px]
        mt-[${margin_top}px]
        mb-[${margin_bottom}px]
        ml-[${margin_left}px]
        mr-[${margin_right}px]
        ${classes}
      `}
    >
      <h2 className={getCurrentTextStyle(title_style, title_style_enable_responsive, title_style_mobile, title_style_tablet, title_style_ultrawide) || 'b1'}>{article?.title}</h2>
    </div>
  );
};